import type { ComponentType } from 'react';
import type { TenantCampaignWithCapabilitiesDto } from '@signalvote/shared';
import { CommitteeStep } from './ExpressCommitteeStep';
import type { ExpressDraft, SetExpressDraft } from './expressDraft';
import { ReviewStep } from './ExpressReviewStep';
import type { SendStepKey } from './expressSteps';
import { MessageStep, RecipientsStep, ScheduleStep } from './ExpressTextSteps';

/**
 * What every send step receives. A step renders its own `ExpressStep` (fields, order-bar summary,
 * Continue) and calls `onNext` when it is done. `draft` is the device-held draft: a step that runs
 * before the account exists keeps its answers there. `onBack` is absent on the first step shown,
 * `onNext` on the last.
 */
export interface ExpressStepViewProps {
  step: SendStepKey;
  /** Every step this send asks, in order; absent before the account exists. */
  steps?: readonly SendStepKey[];
  /** The Express link's code, on the steps it runs before the account exists; they price from it. */
  code?: string;
  draft: ExpressDraft;
  setDraft: SetExpressDraft;
  /** The selected campaign, on /express/send. Absent before the account exists. */
  campaign?: TenantCampaignWithCapabilitiesDto;
  onBack?: () => void;
  onNext?: () => void;
}

export interface ExpressStepView {
  Component: ComponentType<ExpressStepViewProps>;
}

export const SEND_STEP_VIEWS: Record<SendStepKey, ExpressStepView> = {
  message: { Component: MessageStep },
  recipients: { Component: RecipientsStep },
  schedule: { Component: ScheduleStep },
  registration: { Component: CommitteeStep },
  review: { Component: ReviewStep },
};
